export const tenantAvailableFloorsQueryKeys = {
  all: ['tenant', 'available-floors'] as const,
  lists: () => [...tenantAvailableFloorsQueryKeys.all, 'list'] as const,
  list: (tenantToken: string) =>
    [...tenantAvailableFloorsQueryKeys.lists(), tenantToken] as const,
  infiniteList: (perPage: number) =>
    [
      ...tenantAvailableFloorsQueryKeys.lists(),
      'infinite',
      { perPage },
    ] as const,
};
